import React from 'react';
import PropTypes from 'prop-types';

import PluginsList from './components/PluginsList';
import PlaceholderPluginsList from './components/PlaceholderPluginsList';

import { PluginsListContainer } from './styles';

const PluginSelectionView = ({ plugins, onPluginSelect }) => (
  <PluginsListContainer>
    { plugins
      ? <PluginsList
        plugins={plugins}
        onPluginSelect={onPluginSelect}
      />
      : <PlaceholderPluginsList />
    }
  </PluginsListContainer>
);

PluginSelectionView.propTypes = {
  plugins: PropTypes.array,
  onPluginSelect: PropTypes.func,
};

export default PluginSelectionView;
